module.exports = __webpack_public_path__ + "bacbe1d96c4de076f5a1a6d01d4f82a2.jpg";